module.exports = __webpack_public_path__ + "img/img_43@2x.57368638.png";